import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        let waiting = false;

        this.element.addEventListener('wheel', (e) => {
            e.preventDefault();

            if (waiting) {
                return;
            }

            if (e.deltaY > 0) {
                this.element.scrollTo({ left: this.element.scrollLeft + 100, behavior: 'smooth' });
            } else {
                this.element.scrollTo({ left: this.element.scrollLeft - 100, behavior: 'smooth' });
            }

            waiting = true;
            setTimeout(() => {
                waiting = false;
            }, 200);
        });
    }
}
